import { RouteRoles } from '@/router/role-routes';
import { RouteConfig } from 'vue-router';
import { MarketingFund } from './types';

const routes: RouteConfig[] = [
  {
    path: `/${MarketingFund.Pages.MARKETING_FUND}`,
    name: MarketingFund.Pages.MARKETING_FUND,
    component: () => import(/* webpackChunkName: "marketing-fund" */ './views/MarketingFund.vue'),
    meta: {
      access_roles: RouteRoles[MarketingFund.Pages.MARKETING_FUND],
    },
  },

  {
    path: `/${MarketingFund.Pages.MARKETING_FUND}/:id`,
    name: MarketingFund.Pages.APLICATION_DETAIL,
    component: () => import(/* webpackChunkName: "marketing-fund" */ './views/ApplicationDetail.vue'),
    meta: {
      access_roles: RouteRoles[MarketingFund.Pages.MARKETING_FUND],
    },
  },

  {
    path: `/${MarketingFund.Pages.MARKETING_FUND}/:id/${MarketingFund.Pages.NEW_EVENT}`,
    name: MarketingFund.Pages.NEW_EVENT,
    component: () => import(/* webpackChunkName: "new_event" */ './views/AddNewEvent.vue'),
    meta: {
      access_roles: RouteRoles[MarketingFund.Pages.MARKETING_FUND],
    },
  },

  {
    path: `/${MarketingFund.Pages.MARKETING_FUND}/:id/${MarketingFund.Pages.EDIT_EVENT}/:event_id`,
    name: MarketingFund.Pages.EDIT_EVENT,
    component: () => import(/* webpackChunkName: "edit_event" */ './views/AddNewEvent.vue'),
    meta: {
      access_roles: RouteRoles[MarketingFund.Pages.MARKETING_FUND],
    },
  },

  {
    path: `/${MarketingFund.Pages.MARKETING_FUND}/:id/${MarketingFund.Pages.EVENT_DETAIL}/:event_id`,
    name: MarketingFund.Pages.EVENT_DETAIL,
    component: () => import(/* webpackChunkName: "event_detail" */ './views/EventDetail.vue'),
    meta: {
      access_roles: RouteRoles[MarketingFund.Pages.MARKETING_FUND],
    },
  },
];

export default routes;
